// ไฟล์: frontend/src/pages/admin/TrainingCourses.js
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import api from '../../services/api';
import Swal from 'sweetalert2';

function AdminTrainingCourses() {
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    course_name: '',
    organizer: '',
    description: '',
    hours: '',
    course_type: 'workshop'
  });
  const [formMode, setFormMode] = useState('add'); // 'add' หรือ 'edit'
  
  useEffect(() => {
    fetchCourses();
  }, []);
  
  const fetchCourses = async () => {
    try {
      setIsLoading(true);
      const response = await api.trainingCourse.getAllCourses();
      setCourses(response.data.data || []);
    } catch (error) {
      console.error('Error fetching courses:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลหลักสูตรได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleShowAddModal = () => {
    setFormData({
      id: '',
      course_name: '',
      organizer: '',
      description: '',
      hours: '',
      course_type: 'workshop'
    });
    setFormMode('add');
    setShowModal(true);
  };
  
  const handleShowEditModal = (course) => {
    setFormData({
      id: course.id,
      course_name: course.course_name,
      organizer: course.organizer,
      description: course.description || '',
      hours: course.hours,
      course_type: course.course_type
    });
    setFormMode('edit');
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ตรวจสอบข้อมูลที่จำเป็น
    if (!formData.course_name || !formData.organizer || !formData.hours || !formData.course_type) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        text: 'กรุณากรอกชื่อหลักสูตร, หน่วยงานผู้จัด, จำนวนชั่วโมง และประเภทการอบรม',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    try {
      setIsLoading(true);
      
      let response;
      if (formMode === 'add') {
        // เพิ่มหลักสูตรใหม่
        response = await api.trainingCourse.createCourse(formData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'เพิ่มหลักสูตรเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      } else {
        // แก้ไขข้อมูลหลักสูตร
        response = await api.trainingCourse.updateCourse(formData.id, formData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'แก้ไขข้อมูลหลักสูตรเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      }
      
      // ปิด Modal และโหลดข้อมูลใหม่
      setShowModal(false);
      fetchCourses();
    } catch (error) {
      console.error('Error saving course:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถบันทึกข้อมูลหลักสูตรได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleDelete = (id, courseName) => {
    Swal.fire({
      title: 'ยืนยันการลบ',
      text: `คุณแน่ใจหรือไม่ว่าต้องการลบหลักสูตร "${courseName}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff6b01',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.trainingCourse.deleteCourse(id);
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            text: 'ลบข้อมูลหลักสูตรเรียบร้อยแล้ว',
            confirmButtonColor: '#ff6b01'
          });
          fetchCourses();
        } catch (error) {
          console.error('Error deleting course:', error);
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถลบข้อมูลหลักสูตรได้',
            confirmButtonColor: '#ff6b01'
          });
        }
      }
    });
  };
  
  // แปลงประเภทการอบรมเป็นภาษาไทย
  const getCourseTypeText = (type) => {
    switch(type) {
      case 'online': return 'อบรมออนไลน์';
      case 'onsite': return 'อบรมแบบเข้าร่วม (Onsite)';
      case 'workshop': return 'อบรมเชิงปฏิบัติการ';
      case 'seminar': return 'สัมมนา';
      case 'other': return 'อื่นๆ';
      default: return type;
    }
  };
  
  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">จัดการหลักสูตรการอบรม</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/admin/dashboard">หน้าหลัก</a>
                  </li>
                  <li className="breadcrumb-item active">หลักสูตรการอบรม</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid">
            <div className="card card-orange">
              <div className="card-header">
                <h3 className="card-title">รายการหลักสูตรการอบรมทั้งหมด</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={handleShowAddModal}
                  >
                    <i className="fas fa-plus"></i> เพิ่มหลักสูตร
                  </button>
                </div>
              </div>
              <div className="card-body">
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: '5%' }}>ลำดับ</th>
                          <th style={{ width: '25%' }}>ชื่อหลักสูตร</th>
                          <th style={{ width: '20%' }}>หน่วยงานผู้จัด</th>
                          <th style={{ width: '10%' }}>จำนวนชั่วโมง</th>
                          <th style={{ width: '20%' }}>ประเภทการอบรม</th>
                          <th style={{ width: '20%' }}>ตัวเลือก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {courses.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">
                              ไม่พบข้อมูลหลักสูตรการอบรม
                            </td>
                          </tr>
                        ) : (
                          courses.map((course, index) => (
                            <tr key={course.id}>
                              <td>{index + 1}</td>
                              <td>
                                {course.course_name}
                                {course.description && (
                                  <small className="d-block text-muted">
                                    {course.description.length > 50
                                      ? course.description.substring(0, 50) + '...'
                                      : course.description}
                                  </small>
                                )}
                              </td>
                              <td>{course.organizer}</td>
                              <td className="text-center">{course.hours}</td>
                              <td>{getCourseTypeText(course.course_type)}</td>
                              <td>
                                <button
                                  className="btn btn-info btn-sm mr-1"
                                  onClick={() => handleShowEditModal(course)}
                                >
                                  <i className="fas fa-edit"></i> แก้ไข
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(course.id, course.course_name)}
                                >
                                  <i className="fas fa-trash"></i> ลบ
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      
      {/* Modal เพิ่ม/แก้ไขข้อมูลหลักสูตร */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  {formMode === 'add' ? 'เพิ่มหลักสูตรการอบรมใหม่' : 'แก้ไขข้อมูลหลักสูตรการอบรม'}
                </h5>
                <button type="button" className="close" onClick={handleCloseModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="form-group">
                    <label>ชื่อหลักสูตร <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="course_name"
                      value={formData.course_name}
                      onChange={handleInputChange}
                      placeholder="เช่น การสอนแบบ Active Learning"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>หน่วยงานผู้จัด <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="organizer"
                      value={formData.organizer}
                      onChange={handleInputChange}
                      placeholder="เช่น สำนักงานคณะกรรมการการศึกษาขั้นพื้นฐาน"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>คำอธิบายหลักสูตร</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      placeholder="รายละเอียดเกี่ยวกับหลักสูตร"
                      rows="3"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>จำนวนชั่วโมง <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className="form-control"
                      name="hours"
                      value={formData.hours}
                      onChange={handleInputChange}
                      placeholder="เช่น 18"
                      min="1"
                      step="0.5"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>ประเภทการอบรม <span className="text-danger">*</span></label>
                    <select
                      className="form-control"
                      name="course_type"
                      value={formData.course_type}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="workshop">อบรมเชิงปฏิบัติการ</option>
                      <option value="online">อบรมออนไลน์</option>
                      <option value="onsite">อบรมแบบเข้าร่วม (Onsite)</option>
                      <option value="seminar">สัมมนา</option>
                      <option value="other">อื่นๆ</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    ยกเลิก
                  </button>
                  <button type="submit" className="btn btn-orange" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</>
                    ) : (
                      <>บันทึก</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          {/* พื้นหลังทึบ */}
          <div className="modal- fade show"></div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}

export default AdminTrainingCourses;